import { RootState } from '../store';
import { CompletedTransaction, MappedTransactions } from './slice';

export const getPendingTransactions = (state: RootState): string[] => state.transactions.pending;

export interface TransactionInfo {
  summary: string;
  hash: string;
  chainId: number;
  status?: number;
  addedTime?: string;
  confirmedTime?: string;
}

export const getTransactions = (state: RootState): TransactionInfo[] => {
  const data = state.transactions.data;
  return state.transactions.transactions
    .map((hash) => ({
      summary: data[hash].summary,
      hash,
      chainId: data[hash].chainId,
      status: data[hash].status,
      addedTime: data[hash].addedTime ? new Date(data[hash]?.addedTime || 1 * 1000).toDateString() : '',
      confirmedTime: data[hash].confirmedTime
        ? new Date(data[hash]?.confirmedTime || 1 * 1000).toDateString()
        : 'Pending...',
    }))
    .reverse();
};

export const getTransactionsData = (state: RootState): MappedTransactions => state.transactions.data;

export const getTransaction = (state: RootState, hash: string): CompletedTransaction | undefined =>
  state.transactions.data[hash];
